import React from 'react';
import { ShieldCheck, Activity } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const VaccinationPage = () => {
  const config = {
    badge: "Vaccination Sanctuary",
    headline: "Immunity &",
    headlineItalic: "Protection.",
    subtext: "Evidence-based vaccination schedules designed to protect your pet against life-threatening infectious diseases throughout every life stage.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Pet Vaccination at Dr. Suresh Pet Care — Complete Immunization Protocols",
    stats: [
      { value: 10000, suffix: '+', label: 'Pets Vaccinated' },
      { value: 100, suffix: '%', label: 'Licensed Vaccines' },
      { value: 10, suffix: '+', label: 'Disease Categories' },
      { value: 24, suffix: '/7', label: 'Emergency Access' },
    ],
    services: [
      {
        title: "Core Vaccinations",
        icon: <ShieldCheck size={28} />,
        desc: "Essential vaccines every pet requires: Distemper, Parvovirus, Adenovirus, and Rabies protocols.",
        specs: ["Distemper Combo", "Parvovirus", "Rabies Certificate", "Leptospirosis"],
        color: "from-green-500/10 to-primary/10"
      },
      {
        title: "Lifestyle Vaccines",
        icon: <Activity size={28} />,
        desc: "Optional vaccines based on lifestyle risk, including Bordetella, Lyme Disease, and Influenza.",
        specs: ["Bordetella", "Canine Flu", "Lyme Disease", "Rattlesnake Vaccine"],
        color: "from-primary/10 to-blue-500/10"
      },
      {
        title: "Kitten & Puppy Series",
        icon: <ShieldCheck size={28} />,
        desc: "Age-appropriate, staged vaccination schedules to build robust immunity in growing pets.",
        specs: ["6-Week Start", "Booster Schedule", "Maternal Ab Testing", "Titre Testing"],
        color: "from-amber-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Vaccination",
    sectionItalic: "Protocols.",
    warningTitle: "Why Vaccination",
    warningItalic: "Matters.",
    warningText: "Unvaccinated pets are vulnerable to preventable, potentially fatal diseases. Keeping vaccinations current saves lives and reduces healthcare costs.",
    warnings: [
      { name: "Parvovirus", desc: "Highly contagious viral disease in dogs — often fatal without vaccination.", icon: "⚠️" },
      { name: "Distemper", desc: "Multi-system viral disease attacking respiratory, GI, and nervous systems.", icon: "🦠" },
      { name: "Rabies", desc: "Fatal zoonotic viral disease legally requiring vaccination in most areas.", icon: "🚨" },
      { name: "Feline Panleukopenia", desc: "Highly contagious cat disease with high mortality in unvaccinated cats.", icon: "🐱" },
    ],
    ctaBadge: "Preventive Care",
    ctaTitle: "The Vaccination",
    ctaItalic: "Expertise.",
    ctaText: "Our veterinary team administers only licensed, refrigerator-maintained vaccines according to gold-standard WSAVA immunization guidelines in Hyderabad.",
    ctaBtn: "Book Vaccination Appointment",
    seoText: "Expert pet vaccination and immunization in Hyderabad. Complete dog and cat vaccine schedules at Dr. Suresh Pet Care. Anti-rabies and parvovirus vaccination.",
    glowColor: "green-500"
  };

  return (
    <>
      <SEO 
        title="Pet Vaccination & Immunization"
        description="Complete vaccination schedules for dogs and cats at Dr. Suresh Pet Care, Hyderabad. Protect your pet from life-threatening diseases with expert immunization protocols."
        canonical="/vaccination"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default VaccinationPage;
